import { useAuthContext } from "@/components/AuthProvider";

import LoggedInForm from "./ui/LoggedInForm";
import LoggedOutForm from "./ui/LoggedOutForm";

export default function PractitionerApplication({ setFormSubmitted }) {
  const { user } = useAuthContext();

  return user ? (
    <LoggedInForm setFormSubmitted={setFormSubmitted} />
  ) : (
    <LoggedOutForm setFormSubmitted={setFormSubmitted} />
  );
}
